import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AuthProvider, FSMProvider } from "../../../shared/model";
import { DEFAULT_AUTH_ZONE_CFG, DEFAULT_CHARS_LIMIT } from "../../../shared/config";
import { selectIsChatOpen, setWidgetConfig } from "../../../entities/settings/model";
import { useChatEventControl, useRequestInterceptor } from "../../lib/hooks";
import { setWelcomeMessage } from "../../../entities/message/model";
var InterceptorWrapper = function InterceptorWrapper(_ref) {
  var children = _ref.children;
  useRequestInterceptor();
  return children;
};
var EventWrapper = function EventWrapper(_ref2) {
  var children = _ref2.children,
    messengers = _ref2.messengers;
  useChatEventControl(messengers);
  return children;
};
var ConfigWrapperRender = function ConfigWrapperRender(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    authType = props.authType,
    _props$authZoneConfig = props.authZoneConfig,
    authZoneConfig = _props$authZoneConfig === void 0 ? DEFAULT_AUTH_ZONE_CFG : _props$authZoneConfig,
    attachmentsConfig = props.attachmentsConfig,
    baseUrl = props.baseUrl,
    _props$charsLimit = props.charsLimit,
    charsLimit = _props$charsLimit === void 0 ? DEFAULT_CHARS_LIMIT : _props$charsLimit,
    _props$enableQueriesP = props.enableQueriesParams,
    enableQueriesParams = _props$enableQueriesP === void 0 ? true : _props$enableQueriesP,
    _props$messengers = props.messengers,
    messengers = _props$messengers === void 0 ? [] : _props$messengers,
    startButtonsConfig = props.startButtonsConfig,
    userData = props.userData,
    isOpen = props.isOpen,
    welcomeMessage = props.welcomeMessage,
    setConfig = props.setConfig,
    setOperatorWelcomeMessage = props.setOperatorWelcomeMessage,
    apiSettings = props.apiSettings;
  var _useState = useState(userData === null || userData === void 0 ? void 0 : userData.token),
    _useState2 = _slicedToArray(_useState, 2),
    token = _useState2[0],
    setToken = _useState2[1];
  useEffect(function () {
    if (!token && userData !== null && userData !== void 0 && userData.token) {
      setToken(userData.token);
    }
  }, [userData === null || userData === void 0 ? void 0 : userData.token]);
  useEffect(function () {
    setConfig({
      authType: authType,
      authZoneConfig: authZoneConfig,
      baseUrl: baseUrl,
      charsLimit: charsLimit,
      enableQueriesParams: enableQueriesParams,
      messengers: messengers,
      startButtonsConfig: startButtonsConfig,
      userData: {
        token: token
      },
      attachmentsConfig: attachmentsConfig,
      apiSettings: apiSettings,
      welcomeMessage: welcomeMessage
    });
    setOperatorWelcomeMessage(welcomeMessage);
  }, [authType, authZoneConfig, baseUrl, charsLimit, enableQueriesParams, messengers, token, attachmentsConfig, apiSettings, startButtonsConfig]);
  return /*#__PURE__*/React.createElement(FSMProvider, {
    baseUrl: baseUrl,
    isOpen: isOpen,
    zoneType: authZoneConfig.zoneType || 'unauthorized',
    "data-t-id": "ui-ConfigWrapper"
  }, /*#__PURE__*/React.createElement(EventWrapper, {
    messengers: messengers,
    "data-t-id": "ui-ConfigWrapper"
  }, /*#__PURE__*/React.createElement(InterceptorWrapper, {
    "data-t-id": "ui-ConfigWrapper"
  }, /*#__PURE__*/React.createElement(AuthProvider, {
    value: [token, setToken],
    "data-t-id": "ui-ConfigWrapper"
  }, children))));
};
var mapStateToProps = function mapStateToProps(store) {
  return {
    isOpen: selectIsChatOpen(store)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setConfig: function setConfig(cfg) {
      return dispatch(setWidgetConfig(cfg));
    },
    setOperatorWelcomeMessage: function setOperatorWelcomeMessage(text) {
      return dispatch(setWelcomeMessage(text));
    }
  };
};
export var ConfigWrapper = connect(mapStateToProps, mapDispatchToProps)(ConfigWrapperRender);